import Maintenance from "./Maintenance.vue";

export default [
  {
    path: "/maintenance",
    name: "maintenance",
    component: Maintenance,
  },
  {
    path: "*",
    redirect: { name: "maintenance" },
  },
];
